import { Phone } from "lucide-react";

export default function CtaBanner() {
  const leftImage = "/img/contact-us/image 151.svg";

  return (
    <section className="max-w-6xl mx-auto px-4 py-8 md:py-14">
      {/* Main Container */}
      <div
        className="relative overflow-hidden rounded-[28px] text-white"
        style={{
          background:
            "linear-gradient(to right, #6B11D4 0%, #7E22CE 40%, #9333EA 70%, #A855F7 100%)",
        }}
      >
       

        {/* Layout Grid */}
        <div className="relative z-10 flex flex-col md:flex-row items-center">

          {/* Center Content — mobile par pehle */}
          <div className="order-1 md:order-2 flex-1 px-6 pt-6 md:pt-10 lg:pt-12 pb-1 md:py-10 lg:py-12 text-left">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-extrabold leading-tight mb-2">
              Let's Make Your Next Journey
              {/* <br /> */}
              Memorable
            </h2>

            <p className="text-purple-100 text-xs sm:text-sm max-w-md leading-relaxed mb-5">
              Reach out anytime and our team will be happy to assist you.
            </p>

            <button className="inline-flex items-center gap-2 bg-white text-[#6B11D4] font-semibold px-6 py-2.5 rounded-full hover:bg-purple-50 transition-all active:scale-95 text-sm cursor-pointer">
              <Phone size={18} />
              Contact Support
            </button>
          </div>

          {/* Left Image — Suitcase — mobile par baad me, centered */}
          <div className="order-2 md:order-1 flex-shrink-0 flex items-end justify-center md:justify-start px-6 pb-6 pt-4 md:pt-0 md:pb-0 md:pl-8 lg:pl-12 md:self-end">
            <img
              src={leftImage}
              alt="Travel Illustration"
              className="w-52 h-52 sm:w-56 sm:h-56 md:w-52 md:h-52 lg:w-60 lg:h-60 object-contain drop-shadow-2xl"
            />
          </div>

        </div>
      </div>
    </section>
  );
}